// /web/src/pages/Billing.jsx
import React, { useState } from "react";
import { useApi } from "../lib/api";

export default function Billing() {
  const api = useApi();
  const [loading, setLoading] = useState(false);

  const openPortal = async () => {
    setLoading(true);
    try {
      // Calls FastAPI: GET /billing/portal (auth required)
      const data = await api("/billing/portal", { method: "GET" });
      if (data?.url) {
        window.location.href = data.url;
      } else {
        alert("No billing portal available yet. You may need to complete a checkout first.");
      }
    } catch (err) {
      // Common case: 404 from backend if no Stripe customer exists yet
      alert(
        err?.message ||
          "Could not open the billing portal. If you haven’t purchased yet, check the Pricing page first."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ padding: "40px 24px" }}>
      <h1>Billing</h1>
      <p>Manage your subscription, invoices, and payment methods via the Stripe Customer Portal.</p>

      <button
        className="btn btn--primary"
        disabled={loading}
        onClick={openPortal}
        style={{ minWidth: 220 }}
      >
        {loading ? "Opening…" : "Open Billing Portal"}
      </button>

      <p style={{ marginTop: 16, color: "#666", fontSize: 14 }}>
        Tip: The portal becomes available after you complete a checkout at least once.
      </p>
    </div>
  );
}
